export default {
  init() {

    const params = new URLSearchParams(document.location.search);
    const gclid = params.get('gclid');
    if (gclid) {
      const d = new Date();
      d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
      const expires = d.toUTCString();
      document.cookie = `_gclid=${gclid};path=/;expires=${expires};domain=hemsol.se`;
    }

    // Desktop menu dropdowns
    if (document.querySelectorAll('.primary-menu-desktop > .menu-item')) {
      document.querySelectorAll('.primary-menu-desktop > .menu-item').forEach(topLevelLink => {
        let timer = null;
        topLevelLink.addEventListener('mouseenter', (e) => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            topLevelLink.classList.add('active');
          }, 150);
        });
        topLevelLink.addEventListener('mouseleave', (e) => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            topLevelLink.classList.remove('active');
          }, 150);
        });
      });
    }

    // Mobile menu navigation
    if (document.querySelectorAll('button[data-sub-menu-id')) {
      document.querySelectorAll('button[data-sub-menu-id').forEach(mobileMenuButton => {
        mobileMenuButton.addEventListener('click', (e) => {
          const subMenuID = mobileMenuButton.dataset.subMenuId;
          const subMenu = document.querySelector(`li[data-sub-menu="${subMenuID}"]`);
          document.querySelectorAll('button[data-sub-menu-id').forEach(mobileMenuButton => {
            const otherSubMenuID = mobileMenuButton.dataset.subMenuId;
            if (otherSubMenuID !== subMenuID) {
              const otherSubMenu = document.querySelector(`li[data-sub-menu="${otherSubMenuID}"]`);
              otherSubMenu.dataset.open = false;
            }
          });
          subMenu.dataset.open = subMenu.dataset.open === 'true' ? false : true;
        });
      });
    }


    // JavaScript to be fired on all pages
    // document.getElementById('hamburger').onclick = function () {
    //   document.body.classList.toggle('mobile-menu-open');
    //   document.body.classList.remove('header-minimal');
    // }


    // Smooth scroll to #id on click by anchor and on page load
    function scrollToElem(elem) {
      if (elem) {
        const header = document.querySelector('header');
        let headerDropdownHeight = 0;
        if (header.querySelector('.navbar-dropdown')) {
          headerDropdownHeight = header.querySelector('.navbar-dropdown').offsetHeight;
        }
        const headerHeight = header.offsetHeight;
        const bodyScroll = document.body.getBoundingClientRect().top;
        const elementCoordinate = elem.getBoundingClientRect().top;
        window.scrollTo({
          top: elementCoordinate - bodyScroll - headerHeight - headerDropdownHeight,
          behavior: 'smooth',
        })

        if (elem.classList.contains('faq-item')) {
          setTimeout(() => {
            elem.classList.add('open')
          }, 1000);
        }
      }
    }

    document.querySelectorAll('a[href^="#"]').forEach(function (elem) {
      elem.addEventListener('click', (e) => {
        let href = e.target.getAttribute('href');
        if (!href) {
          href = e.target.closest('a').getAttribute('href');
        }
        const hash = href.split('#').slice(-1)[0];
        const scrollTarget = document.getElementById(hash);
        e.preventDefault();
        e.stopPropagation();
        scrollToElem(scrollTarget);
      })
    })

    document.querySelectorAll('.hemsol-accordion').forEach(function (elem) {
      elem.querySelector('.accordion-title').addEventListener('click', () => {
        elem.classList.toggle('open');
      });
    })

    window.onload = function () {
      if (location.hash) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 1)
      }
      // const window_base = window.location.href.split('#').slice(0)[0];
      const window_hash = window.location.hash.split('#').slice(-1)[0];
      if (window_hash) {
        setTimeout(() => {
          const scrollTarget = document.getElementById(window_hash);
          scrollToElem(scrollTarget);
        }, 100);
      }
    };


    // Cookie consist popup
    let cookiePopup = document.querySelector('.cookie-consist');
    const calculator = document.getElementById('hemsol-calculator');
    if (!calculator) {
      if (localStorage.getItem('cookieSeen') != 'shown') {
        cookiePopup.style.display = 'block';
      }
      cookiePopup.querySelector('.button').addEventListener('click', () => {
        cookiePopup.style.display = 'none';
        localStorage.setItem('cookieSeen', 'shown')
      })
    }
  },


  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const faqItemTitles = document.getElementsByClassName('faq-item-title-accordion');
    for (let i = 0; i < faqItemTitles.length; i++) {
      const faqItemTitle = faqItemTitles[i];
      faqItemTitle.onclick = () => {
        faqItemTitle.closest('.faq-item').classList.toggle('open');
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js